module.exports = __webpack_public_path__ + "static/img/nav15.a0077d84.svg";